const BaseModal = require("app/components/modals/BaseModal");
const router = require("app/services/router");
const renderer = require("app/services/renderer");

class Modal extends BaseModal {

	onCloseClick = e => {
		e.preventDefault();
		e.stopPropagation();

		this.close();
	};

	renderHeader() {
		return (
			<div className="modal-header">
				<div className="close-modal" onClick={this.onCloseClick}>
					<img src={router.url("img/icons/close.svg")} alt="Close modal"/>
				</div>
			</div>
		);
	}

}

module.exports = Modal;
